import FormPIN from "@components/inputs/FormPIN";
import { usePostLoginCheck } from "@components/utils/Auth/hooks";
import { LoginCallbackProps } from "@components/utils/Auth/types";
import { useOnboardingPhone } from "@hooks/useOnboardingPhone";

interface LoginPPProps extends LoginCallbackProps {}

const LoginPP = ({ onForgotSecret, onLoginSuccess }: LoginPPProps) => {
  const { phone } = useOnboardingPhone();
  const postLoginCheck = usePostLoginCheck({
    onLoginSuccess,
  });

  return (
    <FormPIN
      phone={phone}
      onLoginSuccess={postLoginCheck}
      onForgotSecret={onForgotSecret}
      isInputNum={false}
    />
  );
};

export default LoginPP;
